import { ITransaction } from '@/entities/transaction';

import { VabsPaymentDirection } from '@/shared/api';
import { ArrowUpIcon, Plus2 } from '@/shared/assets';
import { formatAmountValue, getValueWithCurrency } from '@/shared/lib';
import { shortText } from '@/shared/lib/utils/text';
import { Avatar, Heading, Typography } from '@/shared/ui';

import { FINAL_STATUSES } from '../../config';

export const TransactionDetailHead = ({
  tx,
  onClose,
}: {
  tx: ITransaction;
  onClose: () => void;
}) => {
  const isTopUp = tx.type === VabsPaymentDirection.Incoming;
  const isSend = tx.type === VabsPaymentDirection.Outgoing;

  return (
    <div className="mb-10 mt-14 flex flex-col items-center">
      <Avatar className="mb-5 flex size-20 items-center justify-center bg-white">
        {isTopUp && (
          <Plus2 className="min-h-12 min-w-12 [&_path]:fill-icon-contrast-500" />
        )}
        {isSend && <ArrowUpIcon className="text-icon-contrast-500" />}
      </Avatar>

      <Heading className="mb-4" tag="span" variant="l">
        {getValueWithCurrency(
          formatAmountValue(isTopUp ? tx.sourceAmount : tx.sourceTotalAmount),
          tx.sourceCurrency,
        )}
      </Heading>

      {isTopUp && (
        <div className="flex flex-col items-center">
          <Typography variant="16-m-caps">added to your:</Typography>
          <Typography variant="16-m-caps">{`${tx.sourceCurrency} account`}</Typography>
        </div>
      )}

      {isSend && (
        <div className="flex flex-col items-center">
          <Typography variant="16-m-caps">
            {!FINAL_STATUSES.includes(tx.status) ? 'sending to:' : 'sent to:'}
          </Typography>
          <Typography variant="16-m-caps">
            {shortText(tx.accountHolder || tx.name, 24)}
          </Typography>
        </div>
      )}
    </div>
  );
};
